import React from "react";

import Button from "@material-ui/core/Button";
import { Container } from "@material-ui/core";
import { Redirect, Link } from "react-router-dom";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, redirect: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log("Error + errorInfo from Error Boundary:", error, errorInfo);
    if (this.state.hasError) {
      setTimeout(() => this.setState({ redirect: true }), 5000); // TODO improve this system.
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/login" />;
    } else if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Container>
          <h1>Er is iets fout gegaan.</h1>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            color="primary"
            style={{ marginTop: 15 }}
          >
            Terug naar login
          </Button>
          <br />
          <br />
          <Button
            style={{ marginRight: 25 }}
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
          >
            Herladen
          </Button>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
